import axios from 'axios'
import { GoogleLogin } from '@react-oauth/google'
import { useAuth } from '../../context/SecurityContextProvider'
import { useNavigate } from 'react-router-dom'
import { startOnboarding } from '../../utils/onboarding/onboarding'
import { getCurrentUser } from '../api/UserDataService'

function GoogleLoginButton() {
    const { login } = useAuth()
    const navigate = useNavigate()

    const styles = {
        root: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
        }
    }

    const handlePostGoogleLogin = async (response) => {
        const idToken = response?.credential
        if (!idToken) {
            console.error('No Google credential found')
            return
        }

        const URL = `${process.env.REACT_APP_BACKEND_URL}/api/auth/google`

        try {
            // Backend verifies the Google ID token and returns ITS OWN access+refresh pair.
            const { data } = await axios.post(URL, { idToken })
            await login(data) // stores the token pair and loads /users/me
            const me = await getCurrentUser() // full user: userId, didCompleteSetup, hasActiveTier

            if (!me.didCompleteSetup) {
                // Brand-new user (username not yet claimed) — start the onboarding flow.
                startOnboarding(me.userId)
                navigate('/onboarding')
            } else if (!me.hasActiveTier) {
                // Setup done but no active subscription: dropped or failed checkout, or a plan that
                // lapsed. Vibio is paid-only, so route back into onboarding, which resumes at the
                // plan step. Anchoring on hasActiveTier (rather than the localStorage pointer) also
                // covers cleared storage and other devices.
                navigate('/onboarding')
            } else {
                navigate('/studio')
            }
        } catch (error) {
            console.error('Google login failed:', error)
        }
    }

    return (
        <div style={styles.root}>
            <GoogleLogin onSuccess={handlePostGoogleLogin} />
        </div>
    )
}

export default GoogleLoginButton
